import React from 'react'

import { FieldProps, SmokingAllowedString } from '../../../../../../../@types/types'
import { AbstractScreenValidationResult } from '../../../../../../../@types/validation-types'
import ChipOptionField from '../../../../../../common/inputs/chipOptionField/ChipOptionField'

const SmokingAllowed: React.FC<FieldProps<AbstractScreenValidationResult>> = ({
  insertionData,
  screenName,
  onChange,
}) => {
  return (
    <ChipOptionField
      id='smoking-allowed'
      propertyName='smokingAllowed'
      option={insertionData.smokingAllowed}
      options={SmokingAllowedString}
      translation='wizard.screen.flatShareRoomProperties.smokingAllowed.'
      labelTranslationKey='wizard.screen.flatShareRoomProperties.labels.smokingAllowed'
      onChange={(value) => onChange({ screen: screenName, property: 'smokingAllowed' }, value)}
    />
  )
}

export default SmokingAllowed
